import React from 'react';
import validator from 'validator';
import EditPage from '../EditPage';
import UserForm from './UserForm';
import {Auth} from 'aws-amplify';
import GreenLeafApi from '../utils/GreenLeafApi';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ErrorComponent from '../ErrorComponent';
import PropTypes from 'prop-types';

class EditUserPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      errors: {},
      error: null,
      saved: false,
      companiesLoaded: false,
      companies: [],
      initialCompanyUsers: [],
      user: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirmPassword: '',
        role: '',
        companies: []
      },
      isCreating: !props.isInviting && !this.props.location.state,
      isInviting: props.isInviting
    };

    this.saveUser = this.saveUser.bind(this);
    this.updateUserState = this.updateUserState.bind(this);
    this.roleSelected = this.roleSelected.bind(this);
    this.loadCompanies = this.loadCompanies.bind(this);
    this.companiesSelected = this.companiesSelected.bind(this);
    this.validate = this.validate.bind(this);
  }

  async componentDidMount() {
    try {
      if (!this.state.isInviting && !this.state.isCreating) {
        const user = await GreenLeafApi.User.get(this.props.location.state.email);

        const companyUsers = (await GreenLeafApi.CompanyUser.get({ email: user.Username.replace('+', '%2B') }));
        let companies = [];

        for (let i = 0; i < companyUsers.data.length; i++) {
          const company = (await GreenLeafApi.Company.get({ id: companyUsers.data[i].company_id})).data;
          companies.push({ value: company[0].id, label: company[0].name });
        }

        this.setState((prevState) => {
          prevState.initialCompanyUsers = companyUsers.data;
          prevState.user.first_name = (user.UserAttributes.find(a => a.Name === 'custom:first_name') || {}).Value || '';
          prevState.user.last_name = (user.UserAttributes.find(a => a.Name === 'custom:last_name') || {}).Value || '';
          prevState.user.role = (user.UserAttributes.find(a => a.Name === 'custom:role') || {}).Value || '';
          prevState.user.email = user.Username;
          prevState.user.companies = companies;
          return prevState;
        });
      }

      await this.loadCompanies();
    } catch (e) {
      this.setState({error: e.errors});
    }
  }

  async loadCompanies() {
    const companies = (await GreenLeafApi.Company.get());

    if(companies.isOkay) {
      this.setState({ companies: companies.data, companiesLoaded: true });
    } else {
      this.setState({error: companies.errors});
    }
  }

  roleSelected(option) {
    this.setState((prevState) => {
      prevState.user.role = option ? option.value : '';
      prevState.errors.role = null;
      if (prevState.user.role === 'admin') {
        prevState.user.companies = [];
      }
      return prevState;
    });
  }

  companiesSelected(values) {
    this.setState((prevState) => {
      prevState.user.companies = values;
      return prevState;
    });
  }

  createUser = async () => {
    await Auth.signUp({
      username: this.state.user.email,
      password: this.state.user.password,
      attributes: {
        email: this.state.user.email,
        'custom:role': this.state.user.role,
        'custom:first_name': this.state.user.first_name,
        'custom:last_name': this.state.user.last_name
      }
    });

    try {
      this.state.user.companies.forEach(async o => {
        await GreenLeafApi.CompanyUser.create({ company_id: o.value, user_email: this.state.user.email });
      });
    } catch (e) {
      this.setState({error: e.errors});
    }

    toast.success('User successfully added!', {
      position: 'top-center',
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
    });
  };

  updateUser = async () => {
    try {
      await GreenLeafApi.User.update(this.state.user);

      for (let i = 0; i < this.state.initialCompanyUsers.length; i++) {
        await GreenLeafApi.CompanyUser.delete({
          email: this.state.initialCompanyUsers[i].user_email.replace('+', '%2B'),
          company_id: this.state.initialCompanyUsers[i].company_id
        });
      }
      if (this.state.user.role !== 'admin') {
        for (let i = 0; i < this.state.user.companies.length; i++) {
          let company = this.state.user.companies[i];
          await GreenLeafApi.CompanyUser.create({ company_id: company.value, user_email: this.state.user.email });
        }
      }
    } catch (e) {
      this.setState({error: e.errors});
    }
  };

  resetForm = () => {
    this.setState({
      user: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        confirmPassword: '',
        role: '',
        companies: []
      },
      error: null
    });
  };

  async saveUser(event) {
    event.preventDefault();
    if(this.validate(this.state)) {
      if (this.state.isInviting) {
        try {
          this.props.inviteUser(this.state.user);
          this.resetForm();
          toast.success('User successfully invited!', {
            position: 'top-center',
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
          });
        } catch (e) {
          this.setState({ error: [{ msg: e.msg }] });
          window.scrollTo(0, 0);
        }
      } else {
        try {
          if (this.state.isCreating) {
            await this.createUser();
            this.resetForm();
          } else {
            await this.updateUser();
            this.props.history.push('/users');
          }
        } catch(e) {
          switch (e.code) {
            case 'InvalidPasswordException':
              this.setState({ error: [{ msg: 'Invalid password: 8 characters, 1 uppercase, 1 special character, 1 number'}] });
              break;
            default:
              this.setState({ error: [{ msg: e.msg }] });
          }
          window.scrollTo(0, 0);
        }
      }
    }
  }

  updateUserState(event) {
    let errors = this.state.errors;
    const field = event.target.name;
    errors[field] = null;
    let state = { errors, user: this.state.user };
    state.user[field] = event.target.value;
    return this.setState(state);
  }

  cancel = () => {
    this.props.history.push('/users');
  };

  validate() {
    const requiredFields = ['first_name', 'last_name', 'email', 'role'];
    if (this.state.isCreating) requiredFields.concat(['password', 'confirmPassword']);
    let errors = {};

    if(!validator.isEmail(this.state.user['email'])) {
      errors['email'] = 'This must be an email.';
    }

    if(this.state.isCreating && this.state.user['password'] !== this.state.user['confirmPassword']) {
      errors['confirmPassword'] = 'Password does not match.';
    }

    requiredFields.forEach(f => {
      if (validator.isEmpty(this.state.user[f])) {
        errors[f] = 'This is a required field.';
      }
    });

    this.setState({errors: errors});
    return Object.keys(errors).length === 0;
  }


  render() {
    const error = this.state.error ? <ErrorComponent error={this.state.error}/> : '';

    return (
      <div>
        { error }
        <EditPage
          editType={'User'}
          isCreating={this.state.isCreating}
          isInviting={this.state.isInviting}>
          <UserForm
            onSave={this.saveUser}
            onChange={this.updateUserState}
            onChangeSelectRole={this.roleSelected}
            onChangeSelectCompanies={this.companiesSelected}
            onCancel={this.cancel}
            errors={this.state.errors}
            preset={this.state.user}
            isCreating={this.state.isCreating}
            isInviting={this.state.isInviting}
            optionsLoaded={this.state.companiesLoaded}
            companyOptions={this.state.companies.map(c => { return { value: c.id, label: c.name };})}>
          </UserForm>
        </EditPage>

        <ToastContainer
          position="top-center"
          autoClose={1500}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange={false}
          draggablePercent={80}
          pauseOnHover={false}
        />
      </div>
    );
  }
}

EditUserPage.propTypes = {
  isInviting: PropTypes.bool,
  inviteUser: PropTypes.func,
};

export default EditUserPage;



// WEBPACK FOOTER //
// ./src/components/user/EditUserPage.js